import PropTypes from 'prop-types';
import React from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import cn from 'classnames';
import { bindAll } from '@bibliocommons/utils-react';
import Immutable from 'immutable';
import { bibShape } from '@bibliocommons/bc-prop-types';
import JacketCover from '@bibliocommons/shared-jacket-cover';
import BibItemInfo from '../../bib-item-info/components/BibItemInfo.component';

import '../styles/CatalogueResults.scss';

function getJacketCoverSrc(briefInfo) {
  // `jacket` is optional in bibBriefShape and is also explicitly null in real data, so cover both.
  // `get('jacket', Map())` only defaults when the key is ABSENT — an explicit null comes back as
  // null and throws on the next `.get()`; `||` covers absent, null and undefined alike.
  const jacket = (briefInfo && briefInfo.get('jacket')) || Immutable.Map();

  return Immutable.Map({
    small: jacket.get('small'),
    medium: jacket.get('medium'),
    large: jacket.get('large'),
    local_url: jacket.get('local_url'),
    type: jacket.get('type')
  });
}

class CatalogueResults extends React.PureComponent {
  constructor(props) {
    super(props);
    bindAll(this);
  }

  focusOnTitle() {
    if (this._bibItemInfo) {
      this._bibItemInfo.focusOnTitle();
    }
  }

  renderAddOn(briefInfo) {
    if (this.props.renderAddOn) {
      return this.props.renderAddOn(briefInfo);
    }

    return null;
  }

  renderItem(bib) {
    const { availabilityDetailActions } = this.props;
    const briefInfo = bib.get('briefInfo');

    return (
      <div className="catalogue-results-search-result-item">
        <div className="search-result-contents">
          <div className="item-inner-content">
            <div className="jacket-wrapper">
              <JacketCover alt="" format={briefInfo.get('format')} src={getJacketCoverSrc(briefInfo)} size="small" />
            </div>
            <div className="info-content">
              <BibItemInfo
                showAvailability
                bib={bib}
                ref={el => (this._bibItemInfo = el)}
                availabilityDetailActions={availabilityDetailActions}
                compact
              />
              {this.renderAddOn(briefInfo)}
            </div>
          </div>
        </div>
      </div>
    );
  }

  render() {
    const { searchResults, addRowClassNames } = this.props;
    let key = 0;
    return (
      <div className="cp-catalogue-results">
        <ul className="search-results-list">
          {searchResults.map(item => (
            <li key={key++} className={cn('search-results-row', addRowClassNames(item))}>
              {this.renderItem(item)}
            </li>
          ))}
        </ul>
      </div>
    );
  }
}

CatalogueResults.propTypes = {
  searchResults: ImmutablePropTypes.listOf(bibShape),
  availabilityDetailActions: PropTypes.objectOf(PropTypes.func).isRequired,
  addRowClassNames: PropTypes.func,
  renderAddOn: PropTypes.func
};

CatalogueResults.defaultProps = {
  addRowClassNames: () => {}
};

export default CatalogueResults;
